export default {
  apiUrl: {
    permitUrl: {
      getList: "/transport/logistics/getList", //查询列表
      add: "/transport/logistics/add", //添加品牌
      edit: "/transport/logistics/edit", //编辑
      remove: "/transport/logistics/remove" //删除
    }
  }
};
